import {inRange} from 'shared/utils/dateTime';

export function withinPeriod(record: RecordEntry, period: Period): boolean {
  const {dateTime} = record;
  const {from, to} = period;
  return inRange(dateTime, from, to);
}
